export default "__VITE_ASSET__BNhLADPO__"